import React, { useContext, useRef } from 'react'
import SearchContext from 'modules/react/search/SearchContext'
import Filters from 'modules/react/search/Filters'
import Pagination from 'modules/react/search/Pagination'
import Result from 'modules/react/search/Result'
import classNames from 'classnames'
import ResetButton from 'modules/react/search/ResetButton'

export default function SearchContent () {
  const { search, setSearch, results, totalResults, setContainerRef } = useContext(SearchContext)

  const [showFilterMenu, setShowFilterMenu] = React.useState(false)

  const containerRef = useRef(null)

  React.useEffect(() => {
    setContainerRef(containerRef)
  }, [containerRef])

  const toggleFilterMenu = () => setShowFilterMenu(!showFilterMenu)

  const renderTotalText = () => {
    let amountText = totalResults !== 1 ? 'kurser' : 'kursus'
    return `${totalResults} ${amountText} fundet`
  }

  return (
    <div className="search-page__inner page_container" ref={containerRef}>
      <div className="search-page__bg-svg"/>
      <div className="search-page__title-container">
        <div className="search-page__tagline tagline">Kursus på Tietgen</div>
        <h1 className="search-page__title">Kursusoversigt</h1>
      </div>
      <div className="search-page__content-wrap">
        <div className={classNames({
          'search-page__sidebar': true,
          'search-page__sidebar--open': showFilterMenu
        })}>
          <div className="search-page__sidebar-overlay" onClick={toggleFilterMenu}/>
          <div className="search-page__sidebar-inner">
            <div className="search-page__sidebar-header">
              <ResetButton/>
              <div className="search-page__close-icon navigation-icon open" onClick={toggleFilterMenu}><div><></></div></div>
            </div>
            <div className="search-page__sidebar-input">
              <input type="text" placeholder="Søg efter kursus"
                     onChange={(e) => setSearch(e.target.value)}
                     defaultValue={search}
                     className="search-input"
              />
            </div>
            <ResetButton afterSearch={true}/>
            <div className="search-page__sidebar-filters">
              <Filters/>
              <div className="search-page__filter-search-button">
                <button className="button button--full-width" onClick={toggleFilterMenu}>{renderTotalText()}</button>
              </div>
            </div>
          </div>
        </div>
        <div className="search-page__content">
          <div className="search-page__results-header">
            <div className="tagline tagline--primfaded">{renderTotalText()}</div>
            <button className="search-page__filter-button button button--filter" onClick={toggleFilterMenu}>Filter</button>
          </div>
          <div className="search-page__results">
            {results.map((result) => {
              return <Result key={result.id} result={result}/>
            })}
          </div>
          <div className="search-page__results-footer">
            <Pagination/>
          </div>
        </div>
      </div>
    </div>
  )
}